import { observer } from 'mobx-react';
import InputComponent from '../../../../component/InputComponent';
import { Col, Form, Row, Select, Spin } from 'antd';
import {
	accommodationRequest,
	MerchantRequest,
} from '../../../../request/AuthRequest';
import { useEffect, useState } from 'react';
import useStore from '../../../../store';

const MerchantComponent = observer((props) => {
	const { handleChange, onFinish, id, form, visible } = props;
	const [stateLoading, setStateLoading] = useState(true);
	const [cityLoading, setCityLoading] = useState(true);
	const [searchValue, setSearchValue] = useState('');
	const [merchantLookupLoading, setMerchantLookupLoading] = useState(true);
	const [isDisabledSortName, setIsDisabledSortName] = useState(false);
	const [merchantRoleLoading, setMerchantRoleLoading] = useState(true);
	const [merchantRoleList, setMerchantRoleList] = useState([]);
	const {
		AUTH: { stateList, cityList, getStateList, getCityList, getAllByLookupKeyList },
		ACCOMMODATION,
		ACCOMMODATION: {
			merchantDetail,
			getMerchantLookupList,
			merchantLookupList,
		},
	} = useStore();

	const getmerchantapi = async (data) => {
		const alphabeticPattern = /^[a-zA-Z]+$/;
		if (!alphabeticPattern.test(data[0])) {
			ACCOMMODATION.ReadMerchant(data[0]);
		} else {
			form.resetFields([
				'shortName',
				'merchantRole',
				'email',
				'phoneNo',
				'eStateId',
				'eCityId',
				'pinCode',
				'url',
				'merchantDatabase',
				'address',
				'description',
			]);
		}
	};

	const handleKeyDown = (event) => {
		if (event.key === ' ') {
			event.stopPropagation();
		}
	};

	useEffect(() => {
		if (merchantDetail) {
			form.setFieldsValue({
				eMerchantId: merchantDetail.id,
				merchantName: merchantDetail.merchantName,
				shortName: merchantDetail.shortName,
				merchantRole: merchantDetail.merchantRole,
				email: merchantDetail.email,
				phoneNo: merchantDetail.phoneNo,
				eStateId: merchantDetail.eStateId,
				eCityId: merchantDetail.eCityId,
				pinCode: merchantDetail.pinCode,
				url: merchantDetail.url,
				merchantDatabase: merchantDetail.merchantDatabase,
				address: merchantDetail.address,
				description: merchantDetail.description,
				gstIn: merchantDetail.gstIn,
				pan: merchantDetail.pan,
			});
		}
	}, [merchantDetail, form]);
	useEffect(() => {
		const sName = form.getFieldValue("shortName");
		form.setFieldsValue({
			url: `https://${sName}.${process.env.REACT_APP_MERCHANT_BASE_URL || ''}`
		});
	}, [form.getFieldValue("shortName")]);

	useEffect(() => {
		// Fetch roles immediately so the Select can map the ID to a Name
		if (merchantRoleLoading) {
			getAllByLookupKeyList('lookupKey=MerchantRole&isAdmin=false').then((res) => {
				setMerchantRoleList(res);
				setMerchantRoleLoading(false);
			});
		}
	}, []);
	const changeMerchant = (e) => {
		if (merchantLookupList.length) {
			const ifExits = merchantLookupList.find(
				(_X) => _X.eMerchantId === e[0]
			);
			if (ifExits) {
				setIsDisabledSortName(true);
			} else {
				setIsDisabledSortName(false);
			}
		} else {
			setIsDisabledSortName(false);
		}
	};

	return (
		<Form
			id={id}
			layout="vertical"
			form={form}
			onFinish={onFinish}
			autoComplete="off"
		>
			<Row gutter={24}>
				<Col span={8}>
					<InputComponent
						required
						className={'custom-dp-css'}
						mode="tags"
						maxCount={1}
						type="select"
						showSearch={true}
						name="eMerchantId"
						label="Select or Enter Merchant"
						placeholder="Select or Enter Merchant"
						onInputKeyDown={handleKeyDown}
						onFocus={() =>
							merchantLookupLoading &&
							getMerchantLookupList().then(() =>
								setMerchantLookupLoading(false)
							)
						}
						notFoundContent={
							merchantLookupLoading ? (
								<Spin size="small" />
							) : (
								'Enter to add new'
							)
						}
						options={{
							values:
								(merchantLookupList.length &&
									merchantLookupList) ||
								(merchantDetail && [
									{
										eMerchantId:
											merchantDetail &&
											merchantDetail.id &&
											merchantDetail.id,
										merchantName:
											merchantDetail &&
											merchantDetail.merchantName &&
											merchantDetail.merchantName,
									},
								]),
							value_key: 'eMerchantId',
							text_key: 'merchantName',
						}}
						onChange={(e) => {
							getmerchantapi(e);
							merchantDetail && handleChange();
							changeMerchant(e);
						}}
						rules={accommodationRequest.merchantName}
					/>
				</Col>
				<Col span={6}>
					<InputComponent
						required
						name="shortName"
						label="Short Name"
						disabled={isDisabledSortName}
						placeholder="Enter Short Name"
						onChange={handleChange}
						rules={MerchantRequest.shortName}
					/>
				</Col>
				<Col span={6}>
					<InputComponent
						required
						type="select"
						showSearch={true}
						disabled={!!merchantDetail}
						name="merchantRole"
						label="Merchant Role"
						placeholder="Select Merchant Role"
						// onFocus={() => {
						// 	if (merchantRoleLoading) {
						// 		getAllByLookupKeyList('lookupKey=merchantrole&isAdmin=false').then((res) => {
						// 			setMerchantRoleList(res);
						// 			setMerchantRoleLoading(false);
						// 		});
						// 	}
						// }}
						notFoundContent={
							merchantRoleLoading ? (
								<Spin size="small" />
							) : (
								'No Data Found'
							)
						}
						options={{
							values:
								(merchantRoleList.length && merchantRoleList) ||
								(merchantDetail && merchantDetail.merchantRole && [
									{
										lookupIntValue: merchantDetail.merchantRole,
										lookupValue: merchantDetail.merchantRoleName || merchantDetail.merchantRole,
									},
								]) || [],
							value_key: 'lookupIntValue',
							text_key: 'lookupValue',
						}}
						onChange={() => handleChange()}
						rules={MerchantRequest.merchantRole}
					/>
				</Col>
				<Col span={10}>
					<InputComponent
						// required
						name="email"
						label="Email"
						placeholder="Enter Email"
						onChange={handleChange}
						rules={MerchantRequest.email}
					/>
				</Col>
				<Col span={8}>
					<InputComponent
						required
						name="phoneNo"
						label="Phone Number"
						placeholder="Enter Phone Number"
						onChange={handleChange}
						rules={MerchantRequest.phoneNo}
						disabled={visible === 'edit' ? true : false}
					/>
				</Col>
				<Col span={6}>
					<InputComponent
						required
						type="select"
						showSearch={true}
						name="eStateId"
						label="Select State"
						placeholder="Select State"
						onFocus={() =>
							stateLoading &&
							getStateList().then(() => setStateLoading(false))
						}
						notFoundContent={
							stateLoading ? (
								<Spin size="small" />
							) : (
								'No Data Found'
							)
						}
						options={{
							values:
								(stateList.length && stateList) ||
								(merchantDetail && [
									{
										eRegionId:
											merchantDetail &&
											merchantDetail.eStateId &&
											merchantDetail.eStateId,
										regionName:
											merchantDetail &&
											merchantDetail.stateName &&
											merchantDetail.stateName,
									},
								]),
							value_key: 'eRegionId',
							text_key: 'regionName',
						}}
						onChange={() => {
							form.resetFields(['eCityId']);
							setCityLoading(true);
							handleChange();
						}}
						rules={accommodationRequest.state}
					/>
				</Col>
				<Col span={6}>
					<InputComponent
						required
						type="select"
						showSearch={true}
						name="eCityId"
						label="Select City"
						placeholder="Select City"
						onFocus={() =>
							cityLoading &&
							getCityList(form.getFieldValue('eStateId')).then(
								() => setCityLoading(false)
							)
						}
						notFoundContent={
							cityLoading ? (
								<Spin size="small" />
							) : (
								'No Data Found'
							)
						}
						options={{
							values:
								(cityList.length && cityList) ||
								(merchantDetail && [
									{
										eRegionId:
											merchantDetail &&
											merchantDetail.eCityId &&
											merchantDetail.eCityId,
										regionName:
											merchantDetail &&
											merchantDetail.cityName &&
											merchantDetail.cityName,
									},
								]),
							value_key: 'eRegionId',
							text_key: 'regionName',
						}}
						onChange={handleChange}
						rules={accommodationRequest.city}
					/>
				</Col>
				<Col span={6}>
					<InputComponent
						name="pinCode"
						label="Pin Code"
						placeholder="Enter Pin Code"
						onChange={handleChange}
						rules={MerchantRequest.pinCode}
					/>
				</Col>
				<Col span={10}>
					<InputComponent
						name="url"
						disabled
						label="Merchant URL"
						placeholder="Enter Merchant URL"
						onChange={handleChange}
						rules={MerchantRequest.URL}
					/>
				</Col>
				<Col span={8}>
					<InputComponent
						name="merchantDatabase"
						label="Merchant DB Name"
						placeholder="Enter Merchant DB Name"
						onChange={handleChange}
						rules={MerchantRequest.merchantDatabase}
					/>
				</Col>
				<Col span={12}>
					<InputComponent
						required
						type={'textarea'}
						name="address"
						label="Address"
						placeholder="Enter Address"
						onChange={handleChange}
						rules={MerchantRequest.address}
					/>
				</Col>
				<Col span={12}>
					<InputComponent
						type={'textarea'}
						name="description"
						label="Description"
						placeholder="Enter Description"
						onChange={handleChange}
					//rules={MerchantRequest.description}
					/>
				</Col>
				<Col span={10}>
					<InputComponent
						name="gstIn"
						label="GST Number"
						placeholder="Enter GST Number"
						onChange={handleChange}
						rules={MerchantRequest.gst}
					/>
				</Col>
				<Col span={8}>
					<InputComponent
						name="pan"
						label="PAN Number"
						placeholder="Enter PAN Number"
						onChange={(e) => {
							const upperCaseValue =
								e?.target?.value?.toUpperCase?.();
							form.setFieldsValue({ pan: upperCaseValue });
							handleChange();
						}}
						rules={MerchantRequest.pan}
					/>
				</Col>
			</Row>
		</Form>
	);
});

export default MerchantComponent;
